import React from 'react'

import CheckIcon from '../../../assets/icons/check.svg'
import Footnote from '../../../components/footnote/Footnote'

export default function HowItWorksServices () {
  return (
    <div className='d-flex flex-column our-service-container'>
      <div className='web-header text-center py-5 my-5'>Our services</div>
      <div className='row ps-5 pb-5 mb-5'>
        <div className='col-12 col-sm-6 d-flex flex-column ps-1 ps-lg-5'>
          <div className='list-header text-start pb-3'>For employers:</div>
          {ourServiceEmployers.map((text, index) => {
            return (
              <div key={index} className='text-start list-item py-4'>
                <img className='icon-list me-4' src={CheckIcon} alt='check' />
                {text}
              </div>
            )
          })}
        </div>
        <div className='col-12 col-sm-6 d-flex flex-column ps-1 ps-lg-5'>
          <div className='list-header text-start pb-3'>For employees:</div>
          {ourServiceemployees.map((text, index) => {
            return (
              <div key={index} className='text-start list-item py-4'>
                <img className='icon-list me-4' src={CheckIcon} alt='check' />
                {text}
              </div>
            )
          })}
        </div>
      </div>
      <Footnote
        notes={[
          'Subject to terms and conditions',
          '¹ Customization up to the employer’s allotment. Central Bank of Kansas City does not administer nor is liable for Pay on-demand/earned wage access or tips access.',
          '²  Multikrd is not a bank. The Multikrd Prepaid Card is issued by Central Bank of Kansas City, Member FDIC.',
          '³ Central Bank of Kansas City does not administer nor is liable for remittance transfers. Remittance services are provided by Ria Money Transfer. Terms and conditions apply.'
        ]}
      />
    </div>
  )
}

const ourServiceEmployers = [
  'Rewards',
  'Incentives',
  'Communication tools',
  'Reporting tools',
  'Web and mobile apps (iOS & Android)',
  'PEO customized integrations',
  'Modular design and customization'
]

const ourServiceemployees = [
  'Up to 100% earned wage and tip access',
  '1.2m promotions',
  '700,000+ merchant partnerships',
  'Daily essential savings',
  'Easy access to banking services²',
  'International Money Transfers³',
  'AI personalized offers'
]
